import React, { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: '' };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      errorMessage: error?.message || 'Error inesperado en la aplicación.',
    };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Beyond render error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', maxWidth: '640px', margin: '0 auto' }}>
          <h1 style={{ marginBottom: '0.75rem' }}>Algo salió mal</h1>
          <p style={{ marginBottom: '1rem', color: '#4b5563' }}>{this.state.errorMessage}</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              border: 'none',
              borderRadius: '0.75rem',
              background: '#111827',
              color: '#fff',
              padding: '0.75rem 1rem',
              cursor: 'pointer',
            }}
          >
            Recargar página
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
